module.exports = require('react/lib/ReactFragment').create;


/*****************
 ** WEBPACK FOOTER
 ** ../kettle-ui/~/react-addons-create-fragment/index.js
 ** module id = 513
 ** module chunks = 0
 **/